import { RoleEnum } from '@/types/enums/role.enum';
import type { KeyWithFilter } from '@/utils/filter/filter';

export const filters = (): KeyWithFilter[] => [
    {
        key: [
            {
                key: 'errorDetail.code',
                trans: 'code.errorDetailTaskCheck',
                defaultOperator: 'like',
            },
        ],
        type: 'input',
        value: [],
    },
    {
        key: [
            {
                key: 'taskCheck.ticket.customerId',
                trans: 'Customers',
                keyService: 'Customers',
                defaultOperator: '=',
                includeRoles: [RoleEnum.CUSTOMER],
            },
            {
                key: 'taskCheck.assigneeId',
                trans: 'Assignees.violationDetailTaskCheck',
                keyService: 'Assignees',
                defaultOperator: '=',
            },
            {
                key: 'taskCheck.ticketId',
                trans: 'Ticket',
                keyService: 'Tickets',
                defaultOperator: '=',
            },
            {
                key: 'errorTypeId',
                trans: 'ErrorType',
                keyService: 'ErrorTypes',
                defaultOperator: '=',
            },
            {
                key: 'severityLevelId',
                trans: 'SeverityLevels',
                keyService: 'SeverityLevels',
                defaultOperator: '=',
            },
        ],
        type: 'orm',
        value: [],
    },
    {
        key: [
            {
                key: 'createdDate',
                trans: 'createdDate',
                defaultOperator: '=',
            },
        ],
        type: 'date',
        value: [],
    },
];
